import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import { IEDate } from '@appbase/util';
import { openReserveResourceDate } from '@reserve/popup-handler';
import { mapGetters } from 'vuex';
import * as types from '@reserve/store/types'

import WeekItem from './WeekItem.vue';
import reserveHelper from '@reserve/reserve-helper'

@Component({
    components: {
        WeekItem
    },

    computed: mapGetters({
        selectedResources: types.SELECTED_RESOURCE_LIST,
        curCompany: types.CALENDAR_COMPANY,
        curCategory: types.CALENDAR_CATEGORY
    })
})
export default class WeekRowItem  extends Vue {
    @Prop({ type: Object }) item!: reserve.DateItem;

    selectedResources!: reserve.ResourceItemBase[];
    curCompany!: string | null;
    curCategory!: 'FAVORITE' | 'EWS' | 'DB';

    eventsModel: reserve.CalendarItem[] = [];

    @Watch('item')
    itemChanged(newVal: reserve.DateItem) {
        if(newVal.events) {
            this.eventsModel = newVal.events.filter(e => e.id !== 'null');         
        }
    }

    created() {
        if(this.item != null)
            this.itemChanged(this.item);
    }

    onSelectDblClick() {
        if(this.curCompany == null)
            return;

        var target = IEDate(this.item.date);


        let resource: string | undefined;
        const resources = this.selectedResources.filter(r => !reserveHelper.isHeaderType(r.resourceType));
        if (resources.length > 0) {
            resource = resources[0].address;
        }
        openReserveResourceDate(this.curCompany, target, this.curCategory, resource);
    }
}